import ls from 'localstorage-slim';
ls.config.encrypt = true;

export const initials = (name: string | null) => {
  return name
    ? name
        .split(' ')
        .map(n => n[0])
        .join('')
    : null;
};

// export const profileInitials = () => {
//   return initials(ls.get(CLIENT));
// };
